import React, {useState} from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./blockMeaAct.scss"
import {graphql, Link} from "gatsby";
import Heading from "../heading";
import HTMLReactParser from "html-react-parser";
import Media from "../media";
import ActivityModal from "../Modal/Modal";

const BlkMeaAct = ({ content }) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            {isOpen && (
                <ActivityModal isOpen={isOpen} data={content.relationships?.block_featured_activity_modal.block_modal_body?.processed} handleClose={toggleModal}/>
            )}

            <section className="blk-meaAct">
                <Container>
                    <Row>
                        <Col md={3}>
                            {content.relationships.block_featured_activity_medias[0] && <Media media={content.relationships.block_featured_activity_medias[0]} />}
                        </Col>
                        <Col md={4}>
                            <div className="meaActContent">
                                <Heading heading={2} title={content.block_featured_activity_title} description={HTMLReactParser(content.block_featured_activity_desc?.processed)} />
                                <div className="btnList">
                                    {content.block_featured_activity_bn_link && (
                                        <Link to={content.block_featured_activity_bn_link.uri} className="btn btnLight">
                                            <span>{content.block_featured_activity_bn_link?.title}</span>
                                        </Link>
                                    )}
                                    {content.relationships.block_featured_activity_modal?.block_modal_button_title && (
                                        <button className="simpleLink" onClick={toggleModal}>
                                            {content.relationships.block_featured_activity_modal?.block_modal_button_title}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col md={5}>
                            {content.relationships.block_featured_activity_medias[1] && <Media media={content.relationships.block_featured_activity_medias[1]} />}
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export const query = graphql`
  fragment featuredActivity on paragraph__block_featured_activity {
    internal {
        type
    }
    block_featured_activity_bn_link {
      title
      uri
    }
    block_featured_activity_title
    block_featured_activity_link {
      title
      url
    }
    block_featured_activity_desc {
      processed
    }
    relationships {
      block_featured_activity_modal {
        block_modal_body {
          processed
        }
        block_modal_button_title
        block_modal_title
      }
      block_featured_activity_medias {
        relationships {
          ...getImage
        }
      }
    }
  }
`

export default BlkMeaAct